import { Component, input } from '@angular/core';

import { CustomFieldsModel } from '../../../../../../reducers/orm/custom-fields/custom-fields.model';
import { DepartmentModel } from '../../../../../../reducers/orm/department/department.model';
import { LocationModel } from '../../../../../../reducers/orm/location/location.model';
import {
  TimesheetColumns,
  TimesheetCustomFieldsColumns,
} from '../../../../../../reducers/page-filters/page-filters.model';
import { TimesheetRowScheduleModel } from '../../../interfaces';

@Component({
  standalone: false,
  selector: 'timesheet-row-schedule',
  templateUrl: './timesheet-row-schedule.component.html',
  host: {
    class: 'timesheet__schedule-info',
  },
})
export class TimesheetRowScheduleComponent {
  schedule = input.required<TimesheetRowScheduleModel>();

  locations = input.required<{ [id: string]: LocationModel }>();
  department = input.required<DepartmentModel>();

  cols = input<TimesheetColumns>();

  customFields = input<CustomFieldsModel[]>([]);
  customFieldCols = input<TimesheetCustomFieldsColumns>();
}
